import type {ReactElement} from 'react';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import {QRPayloadField} from '@Libraries/qr-code/qr-code.types';
import type {QRLinkFormProps} from './qr-link-form.types';
import {QR_LINK_FORM_STRINGS} from './qr-link-form.types';

export function QRLinkForm({input, issues, variant, onPatch}: QRLinkFormProps): ReactElement {
  const strings = QR_LINK_FORM_STRINGS[variant];
  return (
    <QRField
      label={window.i18next.t(strings.labelKey)}
      placeholder={window.i18next.t(strings.placeholderKey)}
      helpText={strings.helpKey === undefined ? undefined : window.i18next.t(strings.helpKey)}
      value={input.link}
      field={QRPayloadField.LINK}
      issues={issues}
      onValueChange={(link): void => {
        onPatch({link});
      }}
    />
  );
}
